import { render, staticRenderFns } from "./BodyProfitabilityAnalysis.vue?vue&type=template&id=35aeddb7&scoped=true"
import script from "./BodyProfitabilityAnalysis.vue?vue&type=script&lang=js"
export * from "./BodyProfitabilityAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BodyProfitabilityAnalysis.vue?vue&type=style&index=0&id=35aeddb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aeddb7",
  null
  
)

export default component.exports